import { SR_API_ACTION_GET_LISTING_UNITS } from 'api/actionTypes';

import {
  LISTINGS_DATA_MANAGER_VIEW_ID_UNITS,
  makeListingsStateManagerViewPath,
  actionInitializeListingStateView,
  actionListingsStateViewLoadNextPage,
  actionDataTableLoadItems,
} from 'client/helpers/listingsStateManager';

export function makeListingsStateViewId(listing) {
  return [
    LISTINGS_DATA_MANAGER_VIEW_ID_UNITS,
    listing.addressStreetName,
    listing.addressStreetNumber,
    listing.addressZip,
  ].join(':');
}

export default async function getUnits({ state, apiClient }, { listing, loadMoreUnits }) {
  const { addressStreetName, addressStreetNumber, addressZip } = listing;

  const viewId = makeListingsStateViewId(listing);
  const listingsViewPath = makeListingsStateManagerViewPath(viewId);

  if (!state.exists(listingsViewPath)) {
    actionInitializeListingStateView(
      { state },
      {
        viewId,
        count: 4,
        action: SR_API_ACTION_GET_LISTING_UNITS,
        filters: {
          addressStreetName: addressStreetName,
          addressStreetNumber: addressStreetNumber,
          addressZip: addressZip,
          viewingUnitListingId: listing.id,
        },
      },
    );
    await actionListingsStateViewLoadNextPage({ state, apiClient }, { viewId });
  } else if (loadMoreUnits) {
    const listingsViewConfiguration = state.get(listingsViewPath);
    if (!listingsViewConfiguration.isFullyLoaded) {
      await actionDataTableLoadItems(
        { state, apiClient },
        {
          viewId,
          page: 0,
          offset: 4,
          count: listingsViewConfiguration.total - 4,
          action: SR_API_ACTION_GET_LISTING_UNITS,
          filters: listingsViewConfiguration.filters,
        },
      );
    }
  }
}
